import React from "react";
import Navigation from "../../../components/Navigation";
import CreateAgencyForm from "./CreateAgencyForm";

const CreateAgency = () => {
  return (
    <div className="bg-[#F7F7F7] calc-h-header">
      <Navigation />
      <div className="p-[35px] flex-col justify-start items-start gap-[35px] inline-flex w-full">
        <div className="self-stretch justify-between items-center inline-flex">
          <div className="flex justify-between items-center gap-3 w-full">
            <h3 className="text-black text-2xl mb-0 font-semibold font-['Inter'] leading-normal">Create Agency</h3>
          </div>
        </div>
      </div>

      <CreateAgencyForm />
    </div>
  );
};

export default CreateAgency;